module.exports = __webpack_public_path__ + "20_pvis.jpg?70582cdedcfc72fea3ddd7e827bb803d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/20_pvis.jpg
// module id = 173
// module chunks = 0